/**
 * Record color values used for styling pills, tags, etc.
 */
export enum RecordColorEnum {
	DEFAULT = 'um-neutral',

	SLATE = 'slate',
	GRAY = 'gray',
	ZINC = 'zinc',
	NEUTRAL = 'neutral',
	STONE = 'stone',
	RED = 'red',
	ORANGE = 'orange',
	AMBER = 'amber',
	YELLOW = 'yellow',
	LIME = 'lime',
	GREEN = 'green',
	EMERALD = 'emerald',
	TEAL = 'teal',
	CYAN = 'cyan',
	SKY = 'sky',
	BLUE = 'blue',
	INDIGO = 'indigo',
	VIOLET = 'violet',
	PURPLE = 'purple',
	FUCHSIA = 'fuchsia',
	PINK = 'pink',
	ROSE = 'rose',
}
